export const orgColumn = [
    {
        headerName: 'Organization ID',
        field: 'organization_id',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: 'Actions',
        field: 'action',
        minWidth: 90,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Name',
        field: 'org_name',
        minWidth: 150,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Type',
        field: 'org_type',
        minWidth: 150,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Phone Number',
        field: 'org_phone_number',
        minWidth: 120,
        width: 120,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
    },
    {
        headerName: '# of Active Users',
        field: '_count',
        minWidth: 100,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: '# of Max Users',
        field: 'max_user',
        minWidth: 100,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'License Name',
        field: 'license',
        minWidth: 190,
        width: 190,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Start Date',
        field: 'startdate',
        minWidth: 120,
        width: 120,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'End Date',
        field: 'enddate',
        minWidth: 120,
        width: 120,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Org Status',
        field: 'org_status',
        minWidth: 100,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Created Date',
        field: 'created_at',
        minWidth: 120,
        width: 120,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
];

export const userColumn = [
    {
        headerName: 'User ID',
        field: 'user_id',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: 'Actions',
        field: 'action',
        minWidth: 90,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'User Name',
        field: 'name',
        minWidth: 150,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Email',
        field: 'email',
        minWidth: 250,
        width: 250,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Phone Number',
        field: 'phone_number',
        minWidth: 120,
        width: 120,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Role',
        field: 'role',
        minWidth: 100,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Status',
        field: 'is_deleted',
        minWidth: 100,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Created Date',
        field: 'created_at',
        minWidth: 120,
        width: 120,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
];

export const customFieldColDef = [
    {
        headerName: 'Actions',
        field: 'action',
        minWidth: 200,
        flex: 1,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Name',
        field: 'name',
        minWidth: 200,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
    }
]
